exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-key {\n    margin-right: 20px;\n}\n\n.property-value {\n    font-weight: 700;\n}\n\n.current-price {\n    font-size: 1.5em!important;\n}\n\n.diff {\n    font-size: 1.3em!important;\n}\n\n.gain {\n    background-color: #c2f7c2;\n    padding: 5px;\n}\n\n.loss {\n    background-color: #f7c2c2;\n    padding: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/stock-stats/stock-stats.component.css
// module id = ../../../../../src/app/components/stock-stats/stock-stats.component.css
// module chunks = main